module.exports = __webpack_public_path__ + "static/media/tone_analyze_video.603a8cdd.mp4";